import { render, staticRenderFns } from "./lianTiao.vue?vue&type=template&id=7589c844&scoped=true"
import script from "./lianTiao.vue?vue&type=script&lang=js"
export * from "./lianTiao.vue?vue&type=script&lang=js"
import style0 from "./lianTiao.vue?vue&type=style&index=0&id=7589c844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7589c844",
  null
  
)

export default component.exports